import { useTranslationMipManage } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import type { TemplateCategory } from '@dealstack/frontend/shared/components/EmailTemplates/utils/templateCategories';

export const useTemplateCategoryLabel = () => {
	const tMipManage = useTranslationMipManage();

	return (category: TemplateCategory): string => {
		switch (category) {
			case 'invitation':
				return tMipManage('email_templates.list.categories.invitation', {
					defaultValue: 'Invitation emails',
				});
			case 'document_completion':
				return tMipManage('email_templates.list.categories.document_completion', {
					defaultValue: 'Document completion emails',
				});
			case 'kyc':
				return tMipManage('email_templates.list.categories.kyc', {
					defaultValue: 'KYC emails',
				});
			case 'funds_transfer':
				return tMipManage('email_templates.list.categories.funds_transfer', {
					defaultValue: 'Funds transfer emails',
				});
			case 'other':
				return tMipManage('email_templates.list.categories.other', {
					defaultValue: 'Other',
				});
		}
	};
};
